module.exports = __webpack_public_path__ + "static/media/redux-badge.47808011.svg";